import {
  BLOGS_PATH,
  BOOK_ONLINE_ACTION_PATH,
  FORGOT_PASSWORD_PATH,
  LOGIN_PATH,
  NEWS_PATH,
  PRINT_PATH,
  STAFF_PREFIX,
  isMarketingRoute,
} from '@/consts/routes';

/** Auth, thank-you, and other public paths that must not be indexed. */
const NON_INDEXABLE_PATHS = new Set([
  LOGIN_PATH,
  FORGOT_PASSWORD_PATH,
  BOOK_ONLINE_ACTION_PATH,
  '/logout',
  '/event/thank-you',
]);

/**
 * Detail prefixes for CMS pages that are marketing but only listed as exact
 * paths in `isMarketingRoute` (e.g. `/news` but not `/news/[slug]`).
 */
const INDEXABLE_DETAIL_PREFIXES = [`${NEWS_PATH}/`, `${BLOGS_PATH}/`, `${PRINT_PATH}/`];

/**
 * Public marketing routes safe for search indexing.
 * Mirrors `isMarketingRoute`, plus CMS detail prefixes; excludes auth + thank-you + staff.
 */
export function isIndexablePublicPath(pathname) {
  if (!pathname || typeof pathname !== 'string') {
    return false;
  }
  if (pathname === STAFF_PREFIX || pathname.startsWith(`${STAFF_PREFIX}/`)) {
    return false;
  }
  if (NON_INDEXABLE_PATHS.has(pathname)) {
    return false;
  }
  if (isMarketingRoute(pathname)) {
    return true;
  }
  return INDEXABLE_DETAIL_PREFIXES.some(prefix => pathname.startsWith(prefix));
}

/** Next.js `metadata.robots` — allow indexing. */
export const ROBOTS_INDEX = { index: true, follow: true };

/** Next.js `metadata.robots` — block indexing. */
export const ROBOTS_NOINDEX = { index: false, follow: false };

export function robotsMetadataForPath(pathname) {
  return isIndexablePublicPath(pathname) ? ROBOTS_INDEX : ROBOTS_NOINDEX;
}

export function robotsMetaContent(pathname) {
  if (isIndexablePublicPath(pathname)) {
    return 'index, follow';
  }
  return 'noindex, nofollow';
}
